// import Login from "./views/authentication/Login.vue";
// import ForgotPassword from "./views/authentication/ForgotPassword.vue";
import Dashboard from "@/views/cms-mkt/Dashboard.vue";
import Profile from "@/views/cms-mkt/Profile.vue";
import NotificationsCMS from "@/views/cms-mkt/ManageCampaigns.vue";
import ManageAccounts from "@/views/cms-mkt/ManageUsers.vue";
import ManageRewards from "@/views/cms-mkt/ManageRewards.vue";
import ManageGames from "@/views/cms-mkt/ManageGames.vue";
import CoinsCustomer from "@/views/cms-mkt/CoinCampaigns.vue";


export default {
	router: [
		// {
		// 	path: "/",
		// 	name: "loginCMS",
		// 	component: Login,
		// 	meta: { gtm: "Login" },
		// },
		// {
		// 	path: "*",
		// 	name: "noPage",
		// 	component: Login,
		// 	meta: { gtm: "Login" },
		// },
		// {
		// 	path: "/forgot_password",
		// 	name: "forgot_password",
		// 	component: ForgotPassword,
		// },
		{
			path: "/home",
			name: "dashboard",
			component: Dashboard,
			meta: { gtm: "Dashboard" },
		},
		{
			path: "/profile",
			name: "profile",
			component: Profile,
			params: { menu: "profile" },
			meta: { gtm: "Profile" },
		},
		// {
		// 	path: "/customer/notifications",
		// 	name: "customer_notifications",
		// 	component: Notifications,
		// 	params: { menu: "notifications" },
		// 	meta: { gtm: "Notificari" },
		// },
		{
			path: "/manage_users",
			name: "manage_users",
			component: ManageAccounts,
			params: { menu: "manage accounts" },
			meta: { gtm: "Manage accounts" },
		},
		{
			path: "/manage_rewards",
			name: "manage_rewards",
			component: ManageRewards,
			params: { menu: "manage rewards" },
			meta: { gtm: "Manage rewards" },
		},
		{
			path: "/manage_games",
			name: "manage_games",
			component: ManageGames,
			params: { menu: "manage games" },
			meta: { gtm: "Manage games" },
		},
		{
			path: "/sms_push",
			name: "sms_push",
			component: NotificationsCMS,
			params: { menu: "sms push configuration" },
			meta: { gtm: "Sms push configuration" },
		},
		{
			path: "/coins_customer",
			name: "coins_customer",
			component: CoinsCustomer,
			params: { menu: "Customer coins campaign" },
			meta: { gtm: "Customer coins campaign" },
		},
	]
}